import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "align-content-center" }


export default /*#__PURE__*/_defineComponent({
  __name: 'buttonSubmitComponent',
  props: {
    text: {},
    class: {},
    border: {},
    iconImg: {},
    iconClass: {}
  },
  setup(__props: any) {

const props = __props;

  

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("button", {
    type: "submit",
    class: _normalizeClass([props.class.length> 0 ? props.class : 'block w-full rounded-md bg-regal-blue px-3.5  text-center text-sm font-semibold text-white shadow-sm hover:bg-regal-cyan focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'])
  }, [
    _createElementVNode("span", _hoisted_1, [
      (props.iconImg?.length )
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            border: props.border,
            icon: props.iconImg,
            class: _normalizeClass(props.iconClass)
          }, null, 8, ["border", "icon", "class"]))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(props.text), 1)
    ])
  ], 2))
}
}

})